import React from 'react';

const BudgetText = ({label, text}) => {
  return (
    <p className="budget-text-wait-happy">
      {label}
      <span>{text}</span>
    </p>
  );
};

export default BudgetText;
